import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setMember(r.data))
      .catch(() => localStorage.removeItem("bs_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (mobile, otp) => {
    const { data } = await api.post("/auth/login", { mobile, otp });
    localStorage.setItem("bs_token", data.token);
    setMember(data.member);
    return data.member;
  };

  const logout = () => {
    localStorage.removeItem("bs_token");
    setMember(null);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setMember(data);
  };

  return (
    <AuthContext.Provider value={{ member, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
